var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-bar-start"},[_c('menu-toggle'),_c('logo',{staticClass:"logo",attrs:{"is-authenticated":_vm.isAuthenticated,"dashboard-route":_vm.dashboardRoute,"height":'80%'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }